import useGeneralSettingsStore from '../../../stores/GeneralSettings/useGeneralSettingsStore';
import { Classification } from '../../classifications/classification.types';
import {
  GetProductSearchAvailabilityParams,
  onlineProductSearchRepository,
} from '../../products/repositories/productSearch/onlineProductSearch.repository';
import { offlineClassificationsRepository } from '../repositories/offlineClassifications.repository';
import { offlineProductColorsRepository } from '../repositories/offlineProductColors.repository';
import { OfflineClassificationTransformers } from '../transformers/OfflineDatabaseClassification.transformers';
import { OfflineProductColorTransformers } from '../transformers/productColor/OfflineDatabaseProductColor.transformers';
import { createApiSauceResponse } from '../utils/createApiSauceResponse.util';

export const productSearchRepositoryOfflineAdapters: ReturnType<
  typeof onlineProductSearchRepository
> = {
  getProductSearchColors: async (productId: string) => {
    const offlineProductColors = await offlineProductColorsRepository.findByProductId(productId);

    const asListProductColorDTO = offlineProductColors.map(
      OfflineProductColorTransformers.toListProductColorDTO,
    );

    return createApiSauceResponse({ ok: true, data: asListProductColorDTO });
  },
  getProductSearchAvailability: async ({ productColorId }: GetProductSearchAvailabilityParams) => {
    const offlineProductColors = await offlineProductColorsRepository.getById(productColorId);

    return createApiSauceResponse({
      ok: true,
      data: offlineProductColors?.availabilities || [],
    });
  },
  getProductSearchSuggestedClassifications: async ({ productColorId }) => {
    const suggestedClassificationTypeId =
      useGeneralSettingsStore.getState().generalSettings.suggestedClassificationType?.id;

    if (!suggestedClassificationTypeId) {
      return createApiSauceResponse<Classification[], Classification[]>({ ok: true, data: [] });
    }

    const productColor = await offlineProductColorsRepository.getByIdOrFail(productColorId);

    const classifications = await offlineClassificationsRepository.findByIdsAndClassificationTypeId(
      productColor.classificationIds,
      suggestedClassificationTypeId,
    );

    return createApiSauceResponse<Classification[], Classification[]>({
      ok: true,
      data: classifications.map(
        OfflineClassificationTransformers.toProductSearchSuggestedClassifications,
      ),
    });
  },
};
